import { useCallback } from "react";
import { handleError } from "../utils/error-handler";
import { useRowLoading } from "./useRowLoading";

interface Options {
  fetcher: (id: string) => Promise<string>;
  errorFallback?: string;
}

export function usePdfDownload({ fetcher, errorFallback }: Options) {
  const { load, addLoad, removeLoad, isLoading } = useRowLoading();

  const download = useCallback(
    async (id: string) => {
      addLoad(id);
      try {
        const url = await fetcher(id);
        window.open(url);
      } catch (error) {
        handleError(error, errorFallback);
      } finally {
        removeLoad(id);
      }
    },
    [fetcher, errorFallback, addLoad, removeLoad],
  );

  return { download, load, isLoading };
}
